<template>
  <div>
    <el-drawer
      :title="titles"
      :visible.sync="dialogShow"
      direction="rtl"
      :size="size"
      :append-to-body="true"
      :modal-append-to-body="true"
      :wrapperClosable="false"
      withHeader
      ref="drawer"
      :destroy-on-close="true"
      :before-close="handleClose"
    >
      <div class="demo-drawer__content">
        <slot name="header" class="headers"></slot>
        <slot name="body" class="bodys"></slot>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  props: ["title", "dialogShow"],
  props: {
    title: {
      type: String,
      default: ''
    },
    dialogShow: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: '650px'
    }
  },
  data() {
    return {
      loading: false,
      drawerHide: false,
      titles: this.title
    };
  },
  watch: {
    title() {
      this.titles = this.title;
    }
  },
  created() {},
  methods: {
    handleClose(done) {
      this.$emit("handleChange", false);
    },
    cancelForm() {
      this.loading = false;
      this.drawerHide = false;
    }
  }
};
</script>

<style lang="less" >
@import "../../assets/css/edit.less";
div .el-drawer__header {
   margin: 0;
  color: #111;
  font-weight: 700;
  font-size: 20px;
  padding: 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;
}
// .demo-drawer__content,   // 注释是为了解决 门店开支详情 超出
// .demo-drawer__content > div {
//   height: 100%;
// }
.demo-drawer__content {
  .details {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
.el-drawer__body {
  padding: 0 0.2rem;
  overflow: auto;
  margin-bottom: 77px;
}
.drawer-footer {
  position: absolute;
  width: calc(100% - 40px);
  bottom: 0;
  left: 0;
  //   padding: 0.3rem 0.2rem;
  z-index: 1111;
  box-sizing: border-box;
  text-align: right;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  
box-shadow: 0px -10px 20px 0px rgba(17,17,17,0.0400);
}
.drawer-footer .drawer-footer-btns {
  width: 96px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  background: #FFF;
  border: 1px solid #DCDEE0;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ div .v-modal {
  top: 70px;
  height: calc(100% - 70px);
}
</style>

<style lang="less" scoped>
</style>